import styled, { css } from 'styled-components';
import { SCP } from 'ia-react-core/~/interfaces/SCP';

export const StyledButton = styled.button<{ buttonSize?: number; white?: boolean; primaryBackground?: boolean } & SCP<'button'>>`
  display: inline-block;
  background: transparent;
  padding: 0;
  border: 0;
  height: ${({ buttonSize }) => buttonSize}px;
  width: ${({ buttonSize }) => buttonSize}px;
  color: ${({ theme }) => theme.IconButton.color};
  cursor: pointer;
  -webkit-appearance: none;
  outline: none;
  text-align: center;

  &:hover {
    color: ${({ theme }) => theme.IconButton.hoverColor};
  }

  &[disabled], &:disabled {
    color: ${({ theme }) => theme.colors.disabled};
    cursor: default;
  }

  &:focus-visible, &:focus {
    filter: drop-shadow( 0 0 3px ${({ theme }) => theme.colors.focus});
  }

  &:focus:not(&:focus-visible) {
    filter: none;
    box-shadow: none;
  }

  &:active:not(:disabled) {
    color: ${({ theme }) => theme.IconButton.activeColor};
  }

  ${({ white }) => white && css`
    color: ${({ theme }) => theme.colors.white};
  `}

  ${({ primaryBackground }) => primaryBackground && css`
    color: ${({ theme }) => theme.colors.white};
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 4px;
  `}
`;

export const StyledContentWrapper = styled.span`
  position: relative;
`;

// Required to allow clipping of the icon in BadgeButton
export const StyledIconWrapper = styled.span`

`;

export const StyledIcon = styled.svg<{iconSize: number}>`
  position: relative;
  top: 2px;

  ${({ iconSize }) => css`
    height: ${iconSize}px;
    width: ${iconSize}px;
  `}
`;
